import { API_PREFIX } from "./globalConstants";

// import { first } from "lodash";

/**
 * Capitalizes and returns the parameter string.
 *
 * @param {string} string   An input string.
 * @return {string}         The capitalized string.
 */
export const capitalize = (string) => {
  if (string !== null && string !== undefined) {
    let split_str = string
      .split(" ")
      .map(
        (char) =>
          char.charAt(0).toUpperCase() + char.slice(1).toLocaleLowerCase()
      );
    let result = "";
    split_str.forEach((str) => (result += str + " "));
    result = result.trim();
    //return string.charAt(0).toUpperCase() + string.slice(1);
    return result;
  }
  return string;
};

export const initFetchRequest = (url, accessToken) => {
  const myRequest = new Request(`${API_PREFIX}${url}`, {
    method: "GET",
    headers: {
      "Authorization": "Bearer " + accessToken,
      //'Access-Control-Allow-Credentials': 'true',
      "Access-Control-Allow-Origin": "https://portal.computingreapplied.com/",
      // 'Access-Control-Allow-Origin': 'https://localhost:5001/', //we keep this as localhost for testing, will switch out with computingreapplied.com at producyion
      //'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
      //'Access-Control-Allow-Headers': 'Origin, X- Requested - With, Content - Type, Accept',
    },
  });
  return myRequest;
};

export const initPostRequest = (url, accessToken, requestBody) => {
  const myRequest = new Request(`${API_PREFIX}${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + accessToken,
      "Access-Control-Allow-Origin": "https://portal.computingreapplied.com/",
    },
    body: requestBody,
  });
  return myRequest;
};

export const initPutRequest = (url, accessToken, requestBody) => {
  const myRequest = new Request(`${API_PREFIX}${url}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + accessToken,
      "Access-Control-Allow-Origin": "https://portal.computingreapplied.com/",
    },
    body: requestBody,
  });
  return myRequest;
};

export const initDeleteRequest = (url, accessToken) => {
  const myRequest = new Request(`${API_PREFIX}${url}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + accessToken,
      //'Access-Control-Allow-Credentials': 'true',
      "Access-Control-Allow-Origin": "https://portal.computingreapplied.com/",
      // 'Access-Control-Allow-Origin': 'https://localhost:5001/', //we keep this as localhost for testing, will switch out with computingreapplied.com at producyion
      //'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
      //'Access-Control-Allow-Headers': 'Origin, X- Requested - With, Content - Type, Accept',
    },
  });
  return myRequest;
};

export const fetchData = async (myRequest) => {
  return fetch(myRequest)
    .then((response) => {
      if (response.status === 204) {
        return "Study Deleted";
      }
      let dataJSON = response.json();
      return dataJSON;
    })
    .then((data) => {
      return data;
    })
    .catch((jqXHR, textStatus) => {
      console.log("Error calling the Web api:\n" + textStatus + "\n" + jqXHR);
    });
};

export const putData = async (myRequest) => {
  try {
    const response = await fetch(myRequest);
    return response.status;
  } catch (jqXHR) {
    console.log("Error calling the Web api:", jqXHR);
  }
};

// this might be phased out
export const addLocalTimeStr = (data, type) => {
  let result = data;
  result.fullTimeStr = "";
  if (type === "symptom") {
    result.fullEntryTimeStr = new Date(
      `${result.symptoms[0].symptomTime}Z`
    ).toString();
  } else if (type === "meal") {
    result.fullEntryTimeStr = new Date(`${result.timeConsumed}Z`).toString();
  }

  return result;
};

/**
 * Formats the input date into the correct format as seen on the patient
 * profile cards. i.e. 'August 07, 2020 3:36 PM'
 *
 * @param {Date} date       The date that needs to be formatted.
 * @param {Object} months   Every month in the year.
 * @return {string}         String representation of the formatted input date.
 */
export function formatTime(date, monthz) {
  let months = {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December",
  };

  let hrs = date.getHours();
  let min = date.getMinutes();
  if (min < 10) {
    min = "0" + min;
  }
  let timeSuffix = "AM";
  if (hrs >= 12) {
    if (hrs !== 24) {
      timeSuffix = "PM";
    }
    if (hrs > 12) {
      hrs -= 12;
    }
  }
  let dd = String(date.getDate()).padStart(2, "0");
  let mm = String(date.getMonth() + 1); //January is 0!
  let month = months[mm];
  let yyyy = date.getFullYear();
  return (
    month + " " + dd + ", " + yyyy + " " + hrs + ":" + min + " " + timeSuffix
  );
}

export const roundDecimal = (decimalString) => {
  decimalString = String(decimalString);
  if (String(decimalString).includes(":")) {
    return decimalString;
  }
  const roundedNumber = parseFloat(decimalString).toFixed(2);
  if (decimalString.endsWith("g")) {
    return roundedNumber + "g";
  }
  return roundedNumber;
};

/**
 * Fallback text displayed when a date value is missing or null from the API.
 */
export const NO_DATE_TEXT = "No date found";

/**
 * Format a UTC date string into a local time string (HH:MM:SS AM/PM).
 * Returns NO_DATE_TEXT if the input is falsy.
 *
 * @param {string} utcDateStr - UTC date string from the database.
 * @param {string} [timezone] - IANA timezone identifier (e.g. "America/New_York"). Defaults to local.
 * @returns {string} Formatted local time string.
 */
export const formatUTCTime = (utcDateStr, timezone) => {
  const date = parseUTCDate(utcDateStr);
  if (!date) return NO_DATE_TEXT;
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  if (timezone) options.timeZone = timezone;
  return date.toLocaleTimeString("en-US", options);
};

/**
 * Format a UTC date string into a local date string (MM/DD/YYYY).
 * Returns NO_DATE_TEXT if the input is falsy.
 *
 * @param {string} utcDateStr - UTC date string from the database.
 * @param {string} [timezone] - IANA timezone identifier. Defaults to local.
 * @returns {string} Formatted local date string.
 */
export const formatUTCDate = (utcDateStr, timezone) => {
  const date = parseUTCDate(utcDateStr);
  if (!date) return NO_DATE_TEXT;
  const options = { year: "numeric", month: "2-digit", day: "2-digit" };
  if (timezone) options.timeZone = timezone;
  return date.toLocaleDateString("en-US", options);
};

/**
 * Format a backend calendar-date string as MM/DD/YYYY with NO UTC offset math.
 *
 * Daily aggregate endpoints (DailyNutrientTotals, DailyMacroNutrientTotals) send
 * consumedDate as a date label with a midnight placeholder, e.g. "2024-01-01T00:00:00".
 * This does NOT represent midnight UTC — it represents the calendar day "January 1st".
 * Treating it as UTC and converting to a local timezone silently shifts the date
 * backward for every timezone behind UTC (all US timezones):
 *   PST (UTC-8):  "2024-01-01T00:00:00Z" → Dec 31 at 4 PM  ← WRONG
 *   EST (UTC-5):  "2024-01-01T00:00:00Z" → Dec 31 at 7 PM  ← WRONG
 *
 * This function extracts only the YYYY-MM-DD portion and formats it directly,
 * so the displayed date always matches the day the user logged their food.
 *
 * Use this for:     consumedDate from DailyNutrientTotals / DailyMacroNutrientTotals.
 * Use formatUTCDate for: real timestamps that represent a specific instant (symptomTime).
 *
 * @param {string} dateStr - ISO date string from the backend.
 * @returns {string} Calendar date as MM/DD/YYYY, or NO_DATE_TEXT if falsy/invalid.
 */
export const formatCalendarDate = (dateStr) => {
  if (!dateStr) return NO_DATE_TEXT;
  const datePart = String(dateStr).split("T")[0];
  if (!datePart) return NO_DATE_TEXT;
  const [year, month, day] = datePart.split("-");
  if (!year || !month || !day) return NO_DATE_TEXT;
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  if (!/^\d{4}$/.test(year) || !/^\d{2}$/.test(mm) || !/^\d{2}$/.test(dd)) {
    return NO_DATE_TEXT;
  }
  const monthNum = Number(mm);
  const dayNum = Number(dd);
  if (monthNum < 1 || monthNum > 12 || dayNum < 1 || dayNum > 31) {
    return NO_DATE_TEXT;
  }
  return mm + "/" + dd + "/" + year;
};

/**
 * Format graph data for chart display, using calendar-date extraction for
 * consumedDate so the date label always matches the day the user logged their
 * food (no UTC offset shift, no timezone suffix like "PDT").
 *
 * @param {Array} graphData - Raw API data from a daily aggregate endpoint.
 * @returns {Array} Formatted data with date, calories, protein, fats, carbohydrates.
 */
export const formatGraphData = (graphData) => {
  const formattedData = graphData.map((value) => {
    return {
      date: formatCalendarDate(value.consumedDate),
      calories: roundDecimal(
        value.energyKcal || (value.energyKj > 0 ? value.energyKj / 4.184 : "0")
      ),
      protein: roundDecimal(value.proteinG || "0"),
      fats: roundDecimal(value.totalLipidFatG || "0"),
      carbohydrates: roundDecimal(value.carbohydrateByDifferenceG || "0"),
    };
  });
  return formattedData;
};

/**
 * Format a UTC date string into a full local date-time string with seconds.
 * Returns NO_DATE_TEXT if the input is falsy.
 *
 * @param {string} utcDateStr - UTC date string from the database.
 * @param {string} [timezone] - IANA timezone identifier. Defaults to local.
 * @returns {string} Formatted local date-time string.
 */
export const formatUTCDateTime = (utcDateStr, timezone) => {
  const date = parseUTCDate(utcDateStr);
  if (!date) return NO_DATE_TEXT;
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };
  if (timezone) options.timeZone = timezone;
  return date.toLocaleString("en-US", options);
};

/**
 * Get a timezone label for a given IANA timezone.
 *
 * @param {string} [timezone] - IANA timezone identifier. Defaults to local.
 * @param {boolean} [useGeneric=false] - When true, returns a generic abbreviation
 *   (e.g. "ET") instead of the DST-specific form (e.g. "EDT"/"EST").
 * @returns {string} Timezone abbreviation, or the raw timezone string if Intl
 *   cannot resolve it, or "Local" if no timezone is provided.
 */
export const getTimezoneAbbreviation = (timezone, useGeneric = false) => {
  try {
    const options = { timeZoneName: useGeneric ? "shortGeneric" : "short" };
    if (timezone) options.timeZone = timezone;
    return new Intl.DateTimeFormat("en-US", options)
      .formatToParts(new Date())
      .find((p) => p.type === "timeZoneName")?.value ?? timezone ?? "Local";
  } catch {
    return timezone ?? "Local";
  }
};

/**
 * Safely parse a UTC date string from the database into a Date object.
 * Ensures the string is treated as UTC by appending "Z" if missing.
 *
 * @param {string} utcDateStr - UTC date string from the database.
 * @returns {Date|null} Date object representing the parsed UTC instant, or null if invalid.
 */
export const parseUTCDate = (utcDateStr) => {
  if (!utcDateStr) return null;
  const str = String(utcDateStr);
  // If the string already has timezone info (Z, +, or is already a full local string), use as-is
  let date;
  if (str.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(str)) {
    date = new Date(str);
  } else {
    date = new Date(`${str}Z`);
  }
  // If the constructed date is invalid, return null so callers can fall back to NO_DATE_TEXT
  if (Number.isNaN(date.getTime())) {
    return null;
  }
  return date;
};

// Convert UTC date to current time zone
export const convertDate = (date, noTimeZone) => {
  const userDate = parseUTCDate(date);
  if (!userDate) return NO_DATE_TEXT;
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  if (!noTimeZone) {
    options.timeZoneName = "short";
  }
  return userDate.toLocaleDateString("en-US", options);
};
